
import React from 'react';
import { useLanguage } from "@/hooks/useLanguage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { RansomwareItem } from '@/types/dashboard';
import { RansomwareListItem } from "./RansomwareListItem";
import { Link } from 'react-router-dom';

interface RansomwareCardProps {
  ransomwareAttacks: RansomwareItem[];
  isLoading: boolean;
}

export function RansomwareCard({ ransomwareAttacks, isLoading }: RansomwareCardProps) {
  const { t } = useLanguage();

  return (
    <Card className="border-border/50 h-full bg-card/50 backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:border-amber-500/50 group">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl flex items-center">
          <div className="p-2 rounded-lg bg-amber-500/10 mr-3 group-hover:bg-amber-500/20 transition-colors">
            <Lock className="h-5 w-5 text-amber-500" />
          </div>
          <Link to="/ransomware" className="hover:text-amber-500 transition-colors flex-1">
            {t('dashboard.latest_ransomware')}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="flex flex-col gap-2">
                <div className="h-5 w-3/4 bg-secondary/50 animate-pulse rounded-md" />
                <div className="h-4 w-1/4 bg-secondary/30 animate-pulse rounded-md" />
              </div>
            ))}
          </div>
        ) : ransomwareAttacks && ransomwareAttacks.length > 0 ? (
          <div className="space-y-4">
            {ransomwareAttacks.slice(0, 6).map((attack, index) => (
              <Link
                key={index}
                to={`/ransomware/group/${attack.group}`}
                className="block hover:bg-secondary/50 rounded-lg transition-colors"
              >
                <RansomwareListItem attack={attack} />
              </Link>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground text-sm">{t('common.no_results')}</p>
        )}
      </CardContent>
    </Card>
  );
}
